import Box from '@mui/material/Box';
import { Game } from 'functions/src/types/firestore/Game';
import { TransactionActivityTab as TransactionTab } from 'src/components/transaction-activity/TransactionActivityTab';

type TransactionActivityTabProps = Pick<Game, 'id'>;

export const TransactionActivityTab = ({ id }: TransactionActivityTabProps) => {
  return (
    <Box sx={{ px: 6 }}>
      <TransactionTab parent="game" id={id} />
    </Box>
  );
};
